<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="缸号">
        <Input v-model="formValidate.batchNo" disabled></Input>
      </FormItem>
      <FormItem label="重量" prop="weight">
        <Input
          v-model="formValidate.weight"
          placeholder="请输入布匹重量"
        ></Input>
      </FormItem>
      <FormItem label="匹号" prop="pieceNo">
        <Input
          v-model="formValidate.pieceNo"
          placeholder="请输入布匹编号"
          disabled
        ></Input>
      </FormItem>
      <FormItem label="客户匹号" prop="customerPieceNo">
        <Input
          v-model="formValidate.customerPieceNo"
          placeholder="请输入客户匹号"
        ></Input>
      </FormItem>
      <FormItem label="要求码长" prop="standLengthCode">
        <Input
          v-model="formValidate.standLengthCode"
          placeholder="请输入客户要求码长"
        ></Input>
      </FormItem>
      <FormItem label="要求幅宽" prop="standWidth">
        <Input
          v-model="formValidate.standWidth"
          placeholder="请输入客户要求幅宽"
        ></Input>
      </FormItem>
      <FormItem label="客户机器编码" prop="customerMachine">
        <Input
          v-model="formValidate.customerMachine"
          placeholder="请输入客户要求码长"
        ></Input>
      </FormItem>
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: [],

      formValidate: {
        id: '',
        batchId: '',
        batchNo: '',
        weight: '',
        pieceNo: '',
        standLengthCode: '',
        standWidth: '',
        customerMachine: '',
        customerPieceNo: ''
      },
      ruleValidate: {
        weight: [
          {
            required: true,
            message: '布匹重量必须填写',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setBatchData (order) {
      this.formValidate.batchId = order.id
      this.formValidate.batchNo = order.no
    },
    setEditData (data) {
      // id: "",
      // batchId: "",
      // batchNo: "",
      // weight: "",
      // pieceNo: "",
      this.formValidate.id = data.id
      this.formValidate.batchId = data.batch_id
      this.formValidate.weight = data.weight.toString()
      this.formValidate.pieceNo = data.piece_no
      this.formValidate.standLengthCode = data.stand_length_code
      this.formValidate.standWidth = data.stand_width
      this.formValidate.customerMachine = data.customer_machine
      this.formValidate.customerPieceNo = data.customer_piece_no
    },

    handleChange (newTargetKeys) {
      this.formValidate.permissions = newTargetKeys
    },
    filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },

    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
